import React from 'react';
import CreateFolderModal from '../../LayoutComponents/PrivateFlows/FolderModal/FolderModal';
import type { SidebarFolderActions } from './useSidebarFolderActions';

interface SidebarFolderModalProps {
  actions: SidebarFolderActions;
  theme?: 'light' | 'dark';
}

export const SidebarFolderModal: React.FC<SidebarFolderModalProps> = ({
  actions,
  theme,
}) => {
  const { modalState, handleCreateFolderOrUpdate } = actions;
  const { open, updateTarget, parentId, close } = modalState;
  return (
    <CreateFolderModal
      show={open}
      theme={theme}
      onHide={close}
      onCreateFolderOrUpdate={handleCreateFolderOrUpdate}
      data={{
        isSubfolder: parentId !== undefined,
        isEditing: !!updateTarget,
        folder: {
          id: updateTarget?.id ?? '',
          name: updateTarget?.name ?? '',
        },
      }}
    />
  );
};
